/**
 * API Configuration
 * Supports 3 environments: staging, pre, production
 */

export type Environment = "staging" | "pre" | "production" | "local";

interface ApiConfig {
  baseURL: string;
  timeout: number;
  headers?: Record<string, string>;
}

const getEnvironment = (): Environment => {
  const env = import.meta.env.VITE_ENVIRONMENT || import.meta.env.VITE_ENV || import.meta.env.MODE;

 
  if (env === "production" || env === "prod") {
    return "production";
  }
  if (env === "pre" || env === "preproduction") {
    return "pre";
  }
  if (env === "local" || env === "development") {
    return "local";
  }
  return "staging";
};

const API_CONFIGS: Record<Environment, ApiConfig> = {
  local: {
    baseURL:
      import.meta.env.VITE_API_URL_DEVELOPMENT || "http://localhost:9061",
    timeout: 30000,
  },
  staging: {
    baseURL:
      import.meta.env.VITE_API_URL_STAGING || "https://sb-kcc.kido.vn",
    timeout: 30000,
  },
  pre: {
    baseURL: import.meta.env.VITE_API_URL_PRE || "https://pre-kcc.kido.vn",
    timeout: 30000,
  },
  production: {
    baseURL: import.meta.env.VITE_API_URL_PRODUCTION || "https://kcc.kido.vn",
    timeout: 30000,
  },
};

export const getApiConfig = (): ApiConfig => {
  const env = getEnvironment();
  return API_CONFIGS[env];
};

export const getBaseURL = (): string => {
  return getApiConfig().baseURL;
};

export const getCurrentEnvironment = (): Environment => {
  return getEnvironment();
};

